import { dataComponentSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconComponentSolid = /*#__PURE__*/createIcon(dataComponentSolid)
export default IconComponentSolid
